module.exports = __webpack_public_path__ + "img/Upstairs_2_thumbnail.9cd5a6db.jpg";